// Module
var code = " <style ng-bind=\"$ctrl.getStyles()\"></style> ";
// Exports
export default code;